var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegister(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.028,
    height: 23.614,
    viewBox: "0 0 22.028 23.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.028,1.5v20.614H1V1.5A1.5,1.5,0,0,1,2.5,0H20.528A1.5,1.5,0,0,1,21.028,1.5ZM2,21.114H20.028V3H2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,6h9a.5.5,0,0,1,0,1h-9a.5.5,0,0,1,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,9h9a.5.5,0,0,1,0,1h-9a.5.5,0,0,1,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,12h5a.5.5,0,0,1,0,1h-5a.5.5,0,0,1,0-1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.528,
    cy: 17.614,
    r: 2.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.d6831975a8bde691e3b1f0368a351ddc.svg";
export { ForwardRef as ReactComponent };